export default __webpack_public_path__ + "static/media/deactivate.eeb45b91.svg";